import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

const useStyles = createUseStyles((_) => ({
  container: {
    width: "100%",
    height: "var(--app-vh)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    background: "radial-gradient(1200px 600px at 50% -10%, #0F172A 0%, #020617 60%)",
  },
  logo: {
    width: "min(260px, 70vw)",
    height: "auto",
    objectFit: "contain",
    marginBottom: "8px",
  },
  subContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    width: "min(350px, 90vw)",
    marginTop: "36px",
  },
  customLabel: {
    margin: "9px 16px",
    "& .MuiTypography-root": {
      color: colors.WHITE,
      fontFamily: "Poppins-Regular",
      fontSize: 13,
    },
  },
  customCheckbox: {
    "& .MuiSvgIcon-root": {
      fontSize: 13,
      color: colors.WHITE,
    },
  },
  forgotPassword: {
    textAlign: "center",
    marginTop: "17px",
    cursor: "pointer",
  },
  subContainer2: {
    width: "190px",
  },
  /*
   * Refus d'acces apres une authentification reussie.
   *
   * Volontairement sobre : ce n'est pas une erreur de saisie mais un compte mal
   * rattache, et une bordure rouge vif ferait croire a un mauvais mot de passe
   * -- ce que la personne reessaierait dix fois en vain. Le message doit se
   * lire, pas alarmer.
   */
  denialBox: {
    border: `1px solid ${colors.WHITE}40`,
    borderLeft: "3px solid #F59E0B",
    borderRadius: "8px",
    backgroundColor: "rgba(245, 158, 11, 0.08)",
    padding: "12px 14px",
  },
  denialText: {
    textAlign: "left",
    fontSize: 13,
    lineHeight: 1.5,
    cursor: "default",
  },
}));

export default useStyles;
